export default __webpack_public_path__ + "static/media/Activate.5697f381.svg";